export const CREATE_FOLLOWER = 'FOLLOWER/CREATE';
export const LOAD_FOLLOWERS = 'FOLLOWERS/LOAD';
export const DELETE_FOLLOWER = 'FOLLOWER/DELETE';
export const LOADING_STATUS = 'FOLLOWER/LOADING_STATUS';
